import React from "react";
import { useParams } from "react-router-dom";
import './UtilsHome.css';
import Ecocalender from "../Utils/Ecocalendar/Ecocalendar.jsx";
import CurrencyCalculator from "../Utils/CurrencyCalculator/CurrencyCalculator.jsx";
import CurrencyTable from "../Utils/CurrencyTable/CurrencyTable.jsx";
import { useTranslation } from "../../utils/hooks/translateHook";

const UtilsHome = () => {
/*   const { utilSlug } = useParams();
  const ToolComponent = utilsMap[utilSlug]; */
const t= useTranslation();

  return (
    <div className="utils-home">
      <h1> {t('utilities')} </h1>
      <div className="utils-content" >
        <p><CurrencyCalculator /></p>    
        <p className="currencyTable"><CurrencyTable width="724" /></p>
      </div>
      <div className="utils-content"><Ecocalender /></div>
    </div>  
         
  );
};

export default UtilsHome;








/* 
    <div className="utils-home">
     / {ToolComponent ? (
        <>
          <h1>{utilSlug.replace(/-/g, " ")}</h1> 
          <h1>- Utilities -</h1>
          <CurrencyCalculator />
        </>
      ) : (
        <p>❌ Utility not found: {utilSlug}</p>
      )}
    </div> */